

<div class="mat-elevation-z5 section" style="padding:16px;">
  
  <dx-tab-panel [dataSource]="tabDataSource" [selectedIndex]="tabSelectedIndex" (onTitleClick)="onTitleClick($event)">
    <div *dxTemplate="let tab of 'title'">
      <span>{{ tab.title }}</span>
      <i *ngIf="tab.id.EmployeeId" class="dx-icon-close closebtn"  (click)="onCloseTabClicked(tab)"></i>
    </div>
  </dx-tab-panel>
  <div [hidden]="tabSelectedIndex > 0" class="tab-details">
    <div class="grid-wrapper">
      <div *ngIf="showEmployeeSelect === true" class="grid-row-1-col-1" style="padding-top: 10px">
        <dx-select-box [height]="45" [dataSource]="employeeDataSource" displayExpr="FullName" [placeholder]="placeholderEmployeeSelect"
                      valueExpr="EmployeeId" [(value)]="selectedEmployeeId" [visible]="showEmployeeSelect"
                      [showClearButton]="true" (onSelectionChanged)="onSelectionChangedEmployees($event)">
        </dx-select-box>
      </div>
    </div>
  
    <dx-data-grid class="pointer" [dataSource]="dataSource"
                  [rowAlternationEnabled]="true"
                  [columnAutoWidth]="true"
                  [hoverStateEnabled]="true"
                  (onCellClick)="onCellClick($event)" style="margin-top: 10px">
      <dxo-group-panel [visible]="true"></dxo-group-panel>
      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
      <dxo-paging [pageSize]="15"></dxo-paging>
      <dxo-search-panel [visible]="true" [width]="240"></dxo-search-panel>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-export [enabled]="true"></dxo-export>
      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxi-column cellTemplate="cellTemplate" [width]="60" [allowEditing]="false"></dxi-column>
      <dxi-column dataField="EmployeeName" [caption]="this.languageService.LNG('Label.Employee')" [visible]="showEmployeeColumn" sortOrder="asc"></dxi-column>
      <dxi-column dataField="BalanceString" [caption]="this.languageService.LNG('Label.BalanceName')"></dxi-column>
      <dxi-column dataField="GroupName" [caption]="this.languageService.LNG('Label.Group')"></dxi-column>
      <dxi-column dataField="TotalBalanceStartString" [caption]="this.languageService.LNG('Label.StartBalance')"></dxi-column>
      <dxi-column dataField="TotalBalanceUsedString" [caption]="this.languageService.LNG('Label.UsedOrEarned')"></dxi-column>
      <dxi-column dataField="TotalBalanceString" [caption]="this.languageService.LNG('Label.CurrentBalance')"></dxi-column>
      <dxi-column dataField="TotalPlannedAbsenceString" [caption]="this.languageService.LNG('Label.PlannedAbsence')"></dxi-column>
      <div *dxTemplate="let c of 'cellTemplate'">
        <dx-button icon="bookmark" (onClick)="onTabTemplateClick(c.data)"></dx-button>
      </div>
    </dx-data-grid>

  </div>
  <app-employee-list-balance-per-employee [hidden]="tabSelectedIndex === 0" (loading)="onLoadingDetail($event)"
                                 [employeeId]="selectedEmployeeIdFromGrid" [balanceId]="selectedBalanceIdFromGrid" (closeTab)="onCloseTab()">
  </app-employee-list-balance-per-employee>
</div>
